import { motion } from "framer-motion";
import PremiumMobileShowcase from "./MobileShowcase";
import HowItWorks from "./HowaItWorks";

export default function Hero() {
  return (
    <section className="text-center px- md:px-14 pt-8 md:pt-9 pb-36">
      {/* TRUST */}
      <div className="flex items-center justify-center gap-3 mb-10">
        <div className="flex -space-x-3 ml-2">
          <div className="w-9 h-9 rounded-full bg-gray-300 border-2 border-white">
            <img
              alt="image"
              className="h-8 w-9 rounded-full overflow-hidden"
              src="https://mockmind-api.uifaces.co/content/human/218.jpg"
            />
          </div>
          <div className="w-9 h-9 rounded-full bg-gray-400 border-2 border-white">
            <img
              className="w-9 h-8 rounded-full"
              alt="img"
              src="https://mockmind-api.uifaces.co/content/human/221.jpg"
            />
          </div>
          <div className="w-9 h-9 rounded-full bg-gray-500 border-2 border-white">
            <img
              alt="img"
              src="https://mockmind-api.uifaces.co/content/human/222.jpg"
              className="h-8 w-9 rounded-full"
            />
          </div>
          <div className="w-9 h-9 rounded-full bg-gray-500 border-2 border-white">
            <img
              alt="img"
              src="https://mockmind-api.uifaces.co/content/human/217.jpg"
              className="h-8 w-9 rounded-full"
            />
          </div>
          <div
            className="w-9 h-9 rounded-full border-2 border-gray-200 bg-gray-100/10 flex items-center justify-center text-[10px] text-gray-400
backdrop-blur-sm"
          >
            3K+
          </div>
        </div>
        <p className="text-[12px] text-gray-500 -ml-2">
          Trusted by thousands of healthy families
        </p>
      </div>

      {/* HEADING */}
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="
          text-[42px]
          md:text-[65px]
          font-semibold
          text-[#253612]
          leading-[1.1]
          max-w-4xl
          mx-auto
        "
      >
        The Safest Way to <br className="hidden md:block" />
        Shop for Groceries
      </motion.h1>

      {/* TEXT */}
      <p
        className="
        mt-8
        text-[#828583]
        max-w-xl
        mx-auto
        text-sm
        md:text-lg
        leading-relaxed
        font-extralight
      "
      >
        Use the Olive Food Scanner App to Instantly Eliminate <br />
        Harmful Ingredients from Your Family's Diet and Get
        <br /> Expert-Backed Food Insights
      </p>

      {/* BUTTONS */}
      <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-4">
        <button
          className="
          bg-[#253612]
          text-white
          px-7 py-3
          rounded-full
          shadow-md
          hover:scale-105
          transition
        "
        >
           Download for iOS
        </button>

        {/* <button className="text-[#2F3E1F] font-medium">
          Join the Olive Community →
        </button> */}
      </div>

      {/* PHONE */}
      {/* <div className="mt-16 flex justify-center relative">
        <div className="absolute w-72 h-72 bg-gray-300 rounded-xl blur-3xl opacity-25 left-10"></div>
        <div className="absolute w-72 h-72 bg-gray-300 rounded-xl blur-3xl opacity-25 right-10"></div>

        <img
          src="/assets/images/phone.png"
          alt=""
          className="w-[260px] md:w-[340px] relative z-10"
        />
      </div> */}
      <PremiumMobileShowcase />
      <HowItWorks />
    </section>
  );
}